import { FormAttributes } from '@eview/core/domain/form/form-attribute';

export interface FormAttributesState {
  formAttributes: FormAttributes;
  /** Form id for the last successful ListFormAttributes response. */
  loadedFormId: number | null;
}

export const initialFormAttributesState: FormAttributesState = {
  formAttributes: null,
  loadedFormId: null
};
